import React, { useState } from 'react';
import { ThumbsUp, Heart, PartyPopper, Lightbulb } from 'lucide-react';
import { toast } from 'sonner';
import { newsFeedAPI } from '../../lib/api';

export const REACTIONS = [
  { tipo: 'curtir', label: 'Curtir', icon: ThumbsUp, color: 'text-blue-600', bg: 'bg-blue-50 border-blue-200' },
  { tipo: 'amei', label: 'Amei', icon: Heart, color: 'text-rose-600', bg: 'bg-rose-50 border-rose-200' },
  { tipo: 'parabens', label: 'Parabéns', icon: PartyPopper, color: 'text-amber-600', bg: 'bg-amber-50 border-amber-200' },
  { tipo: 'util', label: 'Útil', icon: Lightbulb, color: 'text-emerald-600', bg: 'bg-emerald-50 border-emerald-200' },
];

export const ReactionCounts = ({ reacoes = {}, testIdPrefix }) => (
  <div className="flex items-center gap-3 flex-wrap">
    {REACTIONS.map(({ tipo, label, icon: Icon, color }) => (
      <span
        key={tipo}
        title={label}
        className={`flex items-center gap-1 text-xs ${reacoes[tipo] ? color : 'text-slate-400'}`}
        data-testid={`${testIdPrefix}-count-${tipo}`}
      >
        <Icon className="w-3.5 h-3.5" />
        {reacoes[tipo] || 0}
      </span>
    ))}
  </div>
);

export const ReactionBar = ({ news, onChange, reactFn = newsFeedAPI.react }) => {
  const [busy, setBusy] = useState(false);
  const react = async (tipo) => {
    if (busy) return;
    const next = news.minha_reacao === tipo ? null : tipo;
    setBusy(true);
    try {
      const res = await reactFn(news.id, next);
      onChange(news.id, res.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao registrar reação');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid grid-cols-4 gap-1.5" data-testid={`reaction-bar-${news.id}`}>
      {REACTIONS.map(({ tipo, label, icon: Icon, color, bg }) => {
        const active = news.minha_reacao === tipo;
        return (
          <button
            key={tipo}
            type="button"
            disabled={busy}
            onClick={(e) => { e.stopPropagation(); react(tipo); }}
            aria-pressed={active}
            data-testid={`reaction-${tipo}-${news.id}`}
            className={`flex flex-col items-center gap-0.5 py-1.5 rounded-lg border text-[11px] font-medium transition-[background-color,transform] active:scale-95 ${
              active ? `${bg} ${color}` : 'border-transparent text-slate-500 hover:bg-slate-50'
            }`}
          >
            <Icon className={`w-4 h-4 ${active ? 'fill-current' : ''}`} />
            <span>{label} {news.reacoes?.[tipo] ? `· ${news.reacoes[tipo]}` : ''}</span>
          </button>
        );
      })}
    </div>
  );
};
